import React from 'react'
import * as S from './styled'

interface Props {
    children?: React.ReactElement
    title: string
    stickyControls?: boolean
    renderControls?: () => React.ReactElement
}

const CollapsedCard: React.FC<Props> = ({ children, ...cardProps }) => {
    return (
        <S.CardContainer {...cardProps}>
            {children}
        </S.CardContainer>
    )
}

export default CollapsedCard
